import React from 'react'
import { connect } from 'react-redux'
import InsuranceActions from '../../Redux/InsuranceRedux'
import Modal from 'react-responsive-modal'
import CreateTicketPackage from '../../Containers/Insurance/CreateTicketPackage'
import UpdateTicketPackage from '../../Containers/Insurance/UpdateTicketPackage'
import EllipsisModal from '../../Components/EllipsisModal'
import FormatMoney from '../../Utils/FormatMoney'
import AdvancedTable from '../../Components/AdvancedTable'

class TicketPackages extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  componentDidMount = () => {
    this._fetchTicketPackages()
  }

  _fetchTicketPackages = (event) => {
    if (event) {
      event.preventDefault()
    }
    this.props.getTicketPackage()
  }

  _deleteTicketPackage = () => {
    let form = {
      status: 0
    }
    let data = {
      id: this.state.detail.id,
      form
    }
    this.props.deleteTicketPackage(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _toggleModal = (action = null) => {
    this.setState({ showModal: action })
    if (!action) {
      this._fetchTicketPackages()
    }
  }

  render () {
    const { insurance } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Ticket Package List
              {
                (insurance.fetching || insurance.processing) &&
                <div className='badge badge-info ml-2'>{ insurance.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-ticket-package')}><i className='fa fa-plus' /> Create Ticket Package</button>
          </div>
        </header>
        {
          !(insurance.fetching || insurance.processing) && insurance.err &&
          <div className='alert alert-danger'>{ insurance.err }</div>
        }
        <AdvancedTable
          colSpan={7}
          header={[
            { field: 'Package Name', className: 'text-left' },
            { field: 'Description' },
            { field: 'Package Price' },
            { field: 'Start Amount' },
            { field: 'End Amount' },
            { field: 'Edit' },
            { field: 'Delete' }
          ]}
          body={
            insurance.data &&
            insurance.data.length > 0 &&
            insurance.data.map(item => ([
              { field: item.name, className: 'text-left' },
              {
                field: <EllipsisModal descriptor='View Description' name={item.name} description={item.description} type='HTML' />
              },
              { field: FormatMoney(item.price) },
              { field: FormatMoney(item.start_amount) },
              { field: FormatMoney(item.end_amount) },
              {
                field: <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-ticket-package')}>
                  <i className='fa fa-edit' />
                </button>
              },
              {
                field: <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-ticket-package')}>
                  <i className='fa fa-trash' />
                </button> }
            ]))
          }
        />
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-ticket-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateTicketPackage closeModal={() => this._toggleModal()} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-ticket-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateTicketPackage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'delete-ticket-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h1 className='title'>Delete Ticket Package</h1>
            </div>
            <div className='text-center mb-3'>
              <h4>{this.state.detail.name}</h4>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteTicketPackage()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  insurance: state.insurance
})

const dispatchToProps = (dispatch) => ({
  getTicketPackage: (data) => dispatch(InsuranceActions.getTicketPackageRequest(data)),
  deleteTicketPackage: (data) => dispatch(InsuranceActions.deleteTicketPackageRequest(data))
})

export default connect(stateToProps, dispatchToProps)(TicketPackages)



// WEBPACK FOOTER //
// ./src/Pages/Insurance/TicketPackageList.js